function EstrellasHero() {
    return (
        <section className="mb-12">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4 leading-tight border-l-4 border-red-500 pl-4">
                Las Estrellas de Aguada
            </h1>
            <p className="text-base sm:text-lg text-slate-400 max-w-2xl leading-relaxed">
                Un recorrido histórico a través de las glorias del Club Atlético Aguada,
                desde el Cuatrienio de Oro hasta la era moderna de la LUB.
            </p>
        </section>
    );
}

export default EstrellasHero;
